"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pagination = exports.OsnTextarea = exports.OsnTagLabelBox = exports.OsnTagLabel = exports.OsnTagField = exports.OsnTabs = exports.OsnTable = exports.OsnSocialPicker = exports.OsnSelect = exports.OsnRange = exports.OsnRadioButton = exports.OsnInputTime = exports.OsnInputText = exports.OsnInputDate = exports.OsnInputCalendar = exports.OsnIconDropdown = exports.OsnIconBox = exports.OsnDoubleToggle = exports.OsnDndUpload = exports.OsnCheckbox = exports.OsnAlertBox = exports.OsnAccordion = exports.Button = void 0;
var _react = _interopRequireDefault(require("react"));
var _Buttons = _interopRequireDefault(require("./buttons/Buttons"));
var _DoubleToggle = _interopRequireDefault(require("./buttons/DoubleToggle"));
var _IconBox = _interopRequireDefault(require("./buttons/IconBox"));
var _CalendarField = require("./inputs/CalendarField");
var _CheckboxField = _interopRequireDefault(require("./inputs/CheckboxField"));
var _InputField = _interopRequireDefault(require("./inputs/InputField"));
var _RadioField = _interopRequireDefault(require("./inputs/RadioField"));
var _RangeField = _interopRequireDefault(require("./inputs/RangeField"));
var _SelectField = _interopRequireDefault(require("./inputs/SelectField"));
var _TagField = _interopRequireDefault(require("./inputs/TagField"));
var _TextareaField = _interopRequireDefault(require("./inputs/TextareaField"));
var _UploadField = _interopRequireDefault(require("./inputs/UploadField"));
var _Accordion = _interopRequireDefault(require("./other/Accordion"));
var _AlertBox = _interopRequireDefault(require("./other/AlertBox"));
var _Paginations = _interopRequireDefault(require("./other/Paginations"));
var _IconDropdown = _interopRequireDefault(require("./other/IconDropdown"));
var _SocialPicker = _interopRequireDefault(require("./other/SocialPicker"));
var _Table = _interopRequireDefault(require("./other/Table"));
var _Tabs = _interopRequireDefault(require("./other/Tabs"));
var _TagLabelBox = require("./other/TagLabelBox");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/*
     ___                     _      
    |_ _|_ __  _ __  ___ _ _| |_ ___
     | || '  \| '_ \/ _ \ '_|  _(_-<
    |___|_|_|_| .__/\___/_|  \__/__/
              |_|                   
*/
// import './styles/Animations.css';
// import './styles/Colors.css';
// import './styles/General.css';

// Buttons

// Input elements

// Other UI elements

/*
     ___                   _      
    | __|_ ___ __  ___ _ _| |_ ___
    | _|\ \ / '_ \/ _ \ '_|  _(_-<
    |___/_\_\ .__/\___/_|  \__/__/
            |_|                   
*/

// Buttons

var Button = function Button(props) {
  return (0, _Buttons["default"])(props);
};
exports.Button = Button;
var OsnDoubleToggle = function OsnDoubleToggle(props) {
  return /*#__PURE__*/_react["default"].createElement(_DoubleToggle["default"], props);
};
exports.OsnDoubleToggle = OsnDoubleToggle;
var OsnIconBox = function OsnIconBox(props) {
  return /*#__PURE__*/_react["default"].createElement(_IconBox["default"], props);
};

// Inputs
exports.OsnIconBox = OsnIconBox;
var OsnInputCalendar = function OsnInputCalendar(props) {
  return /*#__PURE__*/_react["default"].createElement(_CalendarField.CalendarField, props);
};
exports.OsnInputCalendar = OsnInputCalendar;
var OsnInputDate = function OsnInputDate(props) {
  return /*#__PURE__*/_react["default"].createElement(_CalendarField.DateField, props);
};
exports.OsnInputDate = OsnInputDate;
var OsnInputTime = function OsnInputTime(props) {
  return /*#__PURE__*/_react["default"].createElement(_CalendarField.TimeField, props);
};
exports.OsnInputTime = OsnInputTime;
var OsnCheckbox = function OsnCheckbox(props) {
  return /*#__PURE__*/_react["default"].createElement(_CheckboxField["default"], props);
};
exports.OsnCheckbox = OsnCheckbox;
var OsnInputText = function OsnInputText(props) {
  return /*#__PURE__*/_react["default"].createElement(_InputField["default"], props);
};
exports.OsnInputText = OsnInputText;
var OsnRadioButton = function OsnRadioButton(props) {
  return /*#__PURE__*/_react["default"].createElement(_RadioField["default"], props);
};
exports.OsnRadioButton = OsnRadioButton;
var OsnRange = function OsnRange(props) {
  return /*#__PURE__*/_react["default"].createElement(_RangeField["default"], props);
};
exports.OsnRange = OsnRange;
var OsnSelect = function OsnSelect(props) {
  return /*#__PURE__*/_react["default"].createElement(_SelectField["default"], props);
};
exports.OsnSelect = OsnSelect;
var OsnTagField = function OsnTagField(props) {
  return /*#__PURE__*/_react["default"].createElement(_TagField["default"], props);
};
exports.OsnTagField = OsnTagField;
var OsnTextarea = function OsnTextarea(props) {
  return /*#__PURE__*/_react["default"].createElement(_TextareaField["default"], props);
};
exports.OsnTextarea = OsnTextarea;
var OsnDndUpload = function OsnDndUpload(props) {
  return /*#__PURE__*/_react["default"].createElement(_UploadField["default"], props);
};

// Other
exports.OsnDndUpload = OsnDndUpload;
var OsnAccordion = function OsnAccordion(props) {
  return /*#__PURE__*/_react["default"].createElement(_Accordion["default"], props);
};
exports.OsnAccordion = OsnAccordion;
var OsnAlertBox = function OsnAlertBox(props) {
  return /*#__PURE__*/_react["default"].createElement(_AlertBox["default"], props);
};
exports.OsnAlertBox = OsnAlertBox;
var Pagination = function Pagination(props) {
  return /*#__PURE__*/_react["default"].createElement(_Paginations["default"], props);
};
exports.Pagination = Pagination;
var OsnIconDropdown = function OsnIconDropdown(props) {
  return /*#__PURE__*/_react["default"].createElement(_IconDropdown["default"], props);
};
exports.OsnIconDropdown = OsnIconDropdown;
var OsnSocialPicker = function OsnSocialPicker(props) {
  return /*#__PURE__*/_react["default"].createElement(_SocialPicker["default"], props);
};
exports.OsnSocialPicker = OsnSocialPicker;
var OsnTable = function OsnTable(props) {
  return /*#__PURE__*/_react["default"].createElement(_Table["default"], props);
};
exports.OsnTable = OsnTable;
var OsnTabs = function OsnTabs(props) {
  return /*#__PURE__*/_react["default"].createElement(_Tabs["default"], props);
};
exports.OsnTabs = OsnTabs;
var OsnTagLabel = function OsnTagLabel(props) {
  return /*#__PURE__*/_react["default"].createElement(_TagLabelBox.TagLabel, props);
};
exports.OsnTagLabel = OsnTagLabel;
var OsnTagLabelBox = function OsnTagLabelBox(props) {
  return /*#__PURE__*/_react["default"].createElement(_TagLabelBox.TagLabelBox, props);
};
exports.OsnTagLabelBox = OsnTagLabelBox;